import { useMemo } from 'react';
import { useOrgConfigStateValue } from './business/useOrgConfig';

export const useNewQAEnable = () => {
  const { qaEnable, whiteListConfig: { LLM = false } = {} } = useOrgConfigStateValue();

  return useMemo(() => qaEnable || LLM, [qaEnable, LLM]);
};
